module.exports = "/assets/data/85b6334774f21baf9aed519e47adfaf9-NG32.data.json";